import React from 'react'
import LocksLoader from './_load/LocksLoader'
import LocksList from './LocksList'

const LocksContent = ({ checklistId, placeId }) => {
  return (
    <LocksLoader checklistId={checklistId} placeId={placeId}>
      <LocksList />
    </LocksLoader>
  )
}

export default LocksContent
